import EL from '../../EL/EL.js';
import DIV from '../../DOM/div/DIV.js';
import Switchable, { Activate, Deactivate } from '../../../interface/Switchable.js';
import LABEL, { label } from '../../DOM/form/label/LABEL.js';
import PROGRESS, { progress } from '../../DOM/progress/PROGRESS.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
;
// Model Structure
export const progressBarAttr = makeAttrStruct([
    ['value', 0],
    ['min', 0],
    ['max', 100]
]);
export const progressBarData = makeDataStruct([
    ['label'],
    ['progress']
]);
export const progressBarModel = makeStruct([
    ['attributes', progressBarAttr],
    ['data', progressBarData]
]);
// Simplified Model
export function progressbar(labelText, value, min, max) {
    return {
        attributes: progressBarAttr(value, min, max),
        data: progressBarData(label(labelText), progress())
    };
}
/** A progress bar */
export default class PROGRESSBAR extends DIV {
    constructor(node, model) {
        super(node, model);
        this.addClass('progressbar');
        this.implement(new Switchable(this));
        this.label = new LABEL(this, model.data.label);
        this.progress = new PROGRESS(this, model.data.progress);
    }
}
export { Activate, Deactivate, DIV, EL };
